import { NodeModel } from "../_model/NodeModel";
import { DecorationEvaporator } from "./decorationEvaporator";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Evaporator extends NodeModel {
  constructor() {
    super("Evaporator");

    this.type = new Types().Evaporator;

    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 130;
    this.width = 65;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/evaporador.png");
    this.jokerCaption = [];
    this.data = [new Properties({ ...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationEvaporator();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new Evaporator();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
			cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map(d => d.clone());
      cloned.expressionVisible = this.expressionVisible;
      cloned.jokerCaption = this.jokerCaption

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.jokerCaption = node.jokerCaption
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
      this.expressionVisible = node.expressionVisible;
      this.jokerCaption = node.jokerCaption
    };

    this.rebuildStructure = (newProps = []) => {
      let newData = [];
      this.jokerCaption = [];

      newProps.forEach(prop => {
        let equipments = prop.subType == "Equipamentos" && prop.key == "Status";
        let brix = prop.key == "brix" && prop.subType == "Atributos"

        if (equipments || brix) {
          newData.push(new Properties({ ...prop }));
        }
      });
      if (newData.length > 0) this.data = newData;
    }
  }
}

export { Evaporator };
